module.exports = __webpack_public_path__ + "static/media/30OIOS10.5c16be3f.jpg";